
import { defineComponent } from "vue";
import GameWrapper from "@/components/GameWrapper.vue";
import type { FlyOutActionButtonOptions, GameInfo } from "@/data/types";
import CountdownBar from "@/components/CountdownBar.vue";
import Countdown from "@/data/Countdown";
import Equation from "@/data/Equation";
import GameInfoPoint from "@/components/GameInfoPoint.vue";

const actionButtons: FlyOutActionButtonOptions[] = [
  {
    name: "operator1",
    alternative: "↑",
    code: "ArrowUp",
    label: "×",
    clickEvent: {
      event: "commit-operator",
      value: 0,
    },
    isFullSize: true,
    hasFlyOut: true,
    actionCounter: 0,
  },
  {
    name: "operator2",
    alternative: "←",
    code: "ArrowLeft",
    label: "-",
    clickEvent: {
      event: "commit-operator",
      value: 1,
    },
    isFullSize: false,
    hasFlyOut: true,
    actionCounter: 0,
  },
  {
    name: "operator3",
    alternative: "→",
    code: "ArrowRight",
    label: "+",
    clickEvent: {
      event: "commit-operator",
      value: 2,
    },
    isFullSize: false,
    hasExtraBorder: true,
    hasFlyOut: true,
    actionCounter: 0,
  },
];

export default defineComponent({
  name: "PickTheOperator",

  components: {
    GameWrapper,
    CountdownBar,
    GameInfoPoint,
  },

  data() {
    return {
      actionButtons,
      isGameOver: true,
      restartCounter: 0,
      gameCountdown: new Countdown(60) as Countdown,
      gameEquation: new Equation(),
      results: [] as GameInfo[],
    };
  },

  computed: {
    gamePoints(): number {
      let points = 0;
      this.results.forEach((res) => {
        points += res.value ? 1 : -1;
      });
      return points;
    },
  },

  methods: {
    restart(): void {
      this.restartCounter += 1;
      this.isGameOver = false;
      this.gameCountdown.reset();
      this.results = [];
    },

    start() {
      this.gameCountdown.start();
      this.nextEquation();
    },

    nextEquation() {
      this.gameEquation.new();
    },

    endGame(): void {
      this.isGameOver = true;
    },

    commitOperator(index: number) {
      if (this.isGameOver) return;
      this.results.push({
        id: this.results.length,
        info: this.gameEquation.getWithReplacedOperator(
          this.actionButtons[index].label,
          0
        ),
        value: this.gameEquation.hasOperatorAtIndex(
          this.actionButtons[index].label,
          0
        ),
      });
      if (this.actionButtons[index].actionCounter >= 0) {
        this.actionButtons[index].actionCounter += 1;
      } else {
        this.actionButtons[index].actionCounter = 0;
      }
      this.nextEquation();
    },
  },

  watch: {
    gameCountdown: {
      deep: true,
      handler(newVal) {
        if (newVal.isOver) {
          this.endGame();
        }
      },
    },
  },
});
